/* eslint-disable no-unused-vars */
import dayjs from 'dayjs';
import {
    Steps,
    Space,
    Divider,
    Typography,
} from 'antd';
import { FC, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { PageHeader } from '../PageHeader';
import { IBooking } from '../../interfaces/booking.interface';
import { TimelineType } from './TimelineType';

const { Text, Title } = Typography;

const StatusUpdates: FC<Partial<IBooking> & {
    timelineType: boolean;
    handleChangeTimelineType: (type: boolean) => void;
}> = ({
    statusUpdates,
    timelineType,
    handleChangeTimelineType,
}: Partial<IBooking> & {
    timelineType: boolean;
    handleChangeTimelineType: (type: boolean) => void;
}) => {
    const { t } = useTranslation('bookings');

    const getDate = (date: Date) => dayjs(date).format('DD MMM HH:mm');

    return (
        <Space direction="vertical" size={12}>
            <PageHeader
                title={(
                    <Title level={5} style={{ marginBottom: 0 }}>
                        {t('DETAIL.STORY_LINE.TITLE')}
                    </Title>
                )}
                extra={[
                    <TimelineType
                        timelineType={timelineType}
                        handleChangeTimelineType={handleChangeTimelineType}
                    />,
                ]}
                footer={<Divider />}
            />

            <Text>
                {t('DETAIL.STORY_LINE.DESCRIPTION')}
            </Text>

            <div className="booking__timeline" style={{ paddingBottom: 24, overflowX: 'scroll' }}>
                <Steps
                    progressDot
                    current={statusUpdates?.length ? statusUpdates.length - 1 : 0}
                    items={statusUpdates?.map((status) => ({
                        key: status.timeStamp.toString(),
                        title: (
                            <Text strong style={{ fontSize: 14, color: 'var(--color-dark)' }}>
                                {t(`STATUS.${status.newStatusText}`)}
                            </Text>
                        ),
                        subTitle: (
                            <Text className="booking__status--time">
                                {getDate(status.timeStamp)}
                            </Text>
                        ),
                    }))}
                />
            </div>

        </Space>
    );
};

export default memo(StatusUpdates);
